var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-splash',{attrs:{"show":true,"logo":_vm.logo,"custom-text":_vm.information,"color":"#00bfa5","size":300,"fixed":true}})
}
var staticRenderFns = []

export { render, staticRenderFns }